export const REQUEST_ROLLOUTS = 'OVERVIEW_PAGE/REQUEST_ROLLOUTS';

export const SET_ROLLOUTS = 'OVERVIEW_PAGE/SET_ROLLOUTS';
export const SET_ROLLOUTS_ERROR = 'OVERVIEW_PAGE/SET_ROLLOUTS_ERROR';

export const ARCHIVE_ROLLOUT = 'OVERVIEW_PAGE/ARCHIVE_ROLLOUT';
